// components/keyboard/useRegisterShortcuts.ts
import { useEffect } from 'react';
import { shortcutManager } from './shortcutManager';
import { ShortcutConfig } from './types';

export const useRegisterShortcuts = (shortcuts: ShortcutConfig[]) => {
  useEffect(() => {
    console.log(`🔧 Registering ${shortcuts.length} shortcuts...`);
    
    shortcuts.forEach(shortcut => {
      shortcutManager.register(shortcut);
    });

    console.log(`✅ Registered ${shortcuts.length} shortcuts`);

    return () => {
      shortcuts.forEach(shortcut => {
        shortcutManager.unregister(shortcut.id);
      });
    };
  }, [shortcuts]);
};